import { useRef, useEffect } from "react";
const useAutoScroll = (conversationLength, isActivelyStreaming, streamingAIResponse, showWelcome) => {
  const chatWrapperRef = useRef(null);
  const messagesEndRef = useRef(null);
  const shouldScrollOnNextMessageRef = useRef(false);
  const scrollToBottom = () => {
    setTimeout(() => {
      const wrapper = chatWrapperRef.current;
      if (!wrapper) return;
      const targetTop = wrapper.scrollHeight - wrapper.clientHeight;
      wrapper.scrollTo({ top: targetTop, behavior: "smooth" });
    }, 300);
  };
  useEffect(() => {
    if (shouldScrollOnNextMessageRef.current && conversationLength > 0 && !showWelcome) {
      scrollToBottom();
      shouldScrollOnNextMessageRef.current = false;
    }
  }, [conversationLength, showWelcome]);
  useEffect(() => {
    if (isActivelyStreaming && conversationLength > 0 && !showWelcome) {
      scrollToBottom();
    }
  }, [isActivelyStreaming, streamingAIResponse, conversationLength, showWelcome]);
  return {
    chatWrapperRef,
    messagesEndRef,
    shouldScrollOnNextMessageRef,
    scrollToBottom
  };
};
export {
  useAutoScroll
};
//# sourceMappingURL=useAutoScroll.js.map
